import { get, writable } from "svelte/store";
import { replaceStylesheetAnimation, replaceStylesheetKeyframes, } from "../utils/addStylesheetRules";
const initialAnimation = {
    name: "animation-1",
    infinite: true,
    duration: 1,
    delay: 0,
    easing: "linear",
    keyframes: [
        ["0%", [["stroke-dashoffset", 50]]],
        ["100%", [["stroke-dashoffset", 0]]],
    ],
};
function animationStore(initialValue) {
    const { subscribe, set, update } = writable(initialValue);
    return {
        subscribe,
        set: (value) => {
            console.log(value);
            return set(value);
        },
        update,
    };
}
export function addAnimation() {
    animations.update((state) => {
        console.log(state);
        state = [
            ...state,
            writable(Object.assign(Object.assign({}, initialAnimation), { name: `animation-${state.length + 1}` })),
        ];
        return state;
    });
}
export function removeAnimation(idx) {
    animations.update((state) => {
        let newState = [...state];
        newState.splice(idx, 1);
        return newState;
    });
}
export const animations = animationStore([writable(Object.assign({}, initialAnimation))]);
// Initialize animation styles in head
const animationsRaw = get(animations);
replaceStylesheetAnimation(animationsRaw.reduce((acc, store) => [...acc, get(store)], []));
animationsRaw.forEach((store, i) => {
    const animation = get(store);
    replaceStylesheetKeyframes(animation.name, animation.keyframes, i);
});
